import { TITLE_LIST } from "./titleList";

export const TITLES = TITLE_LIST.map((entry) => entry.title);

export function getTitleForLevel(level) {
  const numericLevel = Math.max(1, Number(level) || 1);
  const directMatch = TITLE_LIST.find((entry) => entry.level === numericLevel);
  if (directMatch) return directMatch.title;
  return TITLE_LIST[TITLE_LIST.length - 1]?.title || `Level ${numericLevel}`;
}

// How much XP is needed for a particular level up (not cumulative)
export function xpRequiredForNextLevel(level) {
  return Math.floor(100 * Math.pow(level, 1.45));
}

// The TOTAL (cumulative) XP required to reach a level
export function cumulativeXP(level) {
  let xp = 0;
  for (let i = 1; i < level; i++) {
    xp += xpRequiredForNextLevel(i);
  }
  return xp;
}

// Get the current level, title, current XP in level, and XP needed for next
export function getLevelAndTitle(totalXP) {
  let level = 1;
  while (totalXP >= cumulativeXP(level + 1)) {
    level++;
  }
  const currentTitle = getTitleForLevel(level);
  const xpForPrevLevel = cumulativeXP(level);
  const xpForNextLevel = cumulativeXP(level + 1);
  const currLevelXP = totalXP - xpForPrevLevel;
  const nextLevelXP = xpForNextLevel - xpForPrevLevel;
  return { level, currentTitle, currLevelXP, nextLevelXP };
}
